<nav class="navbar bg-primary navbar-expand-lg d-none d-lg-flex justify-content-between aling-items-center">
  <a
    class="navbar-brand py-0"
    [routerLink]="['/']"
    routerLinkActive="router-link-active"
    attr.aria-label="{{ 'nav.home.page.screenreader' | translate: { fgbdefault: 'Move to home page' } }}"
  >
    <label id="homeLink" class="accessibility-only">Go To Home Page</label>
    <img
      alt="imagedetails"
      class="m-0 h-100"
      aria-labelledby="homeLink"
      [src]="'images/logo.svg' | contentAssetImage"
      draggable="false"
    />
  </a>

  <button
    class="navbar-toggler"
    type="button"
    (click)="displayNavDropdown = !displayNavDropdown"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- middle Side Content -->
  <ul class="navbar-nav" #greedyNav>
    <li class="nav-item active">
      <a
        class="nav-link mx-1"
        [routerLink]="['/rewards']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.rewards.screenreader' | translate: { fgbdefault: 'Move to rewards page' } }}"
        >{{ 'nav.rewards' | translate }}</a
      >
    </li>

    <li class="nav-item active">
      <a
        class="nav-link mx-1"
        [routerLink]="['/challenges-v2']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.badges.screenreader' | translate: { fgbdefault: 'Move to badges page' } }}"
        >{{ 'nav.badges' | translate }}</a
      >
    </li>

    <li class="nav-item active">
      <a
        class="nav-link mx-1"
        [routerLink]="['/payment']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.payment.screenreader' | translate: { fgbdefault: 'Move to payment page' } }}"
        >{{ 'nav.payment' | translate }}</a
      >
    </li>

    <li class="nav-item active">
      <a
        class="nav-link mx-1"
        [routerLink]="['/games']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.earn.screenreader' | translate: { fgbdefault: 'Move to earn page' } }}"
        >{{ 'nav.games' | translate }}</a
      >
    </li>

    <li class="nav-item active">
      <a
        class="nav-link mx-1"
        [routerLink]="['/partner-offers']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.partner.offers.screenreader' | translate: { fgbdefault: 'Move to partner offers page' } }}"
        >{{ 'nav.partner.offers' | translate }}</a
      >
    </li>
  </ul>

  <!-- Right Side Content -->
  <div class="right-side-nav-bar d-flex align-items-center justify=content-center">
    <!-- <div *inPopulation="[populations.GuardianTest]">
      <div *inProductCode="[productcode.PremiumDigitalMember]">
        <fgb-back-to-guardian></fgb-back-to-guardian>
      </div>
    </div> -->

    <div class="ms-2">
      <fgbcl-language-button-select [version]="2" />
    </div>

    <div class="balance-container d-flex align-items-center justify-content-center">
      <div class="balance bg-glass mx-0">
        <div class="d-flex align-items-center justify-content-center" *ngIf="loyaltyPointsCard$">
          <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>
          <label class="fw-bold text-white"
            >{{ loyaltyPointsCard$ | async | number: '1.0-0' }} {{ 'fgbcl.currency.pts' | translate }}</label
          >
        </div>
      </div>

      <div class="balance bg-glass mx-0">
        <div class="d-flex align-items-center justify-content-center" *ngIf="loyaltyPointsCard$">
          <span class="icons material-symbols-outlined text-white"> money_bag </span>
          <label class="fw-bold text-white">{{ combinedCard$ | async | FortressCurrencyPipe }}</label>
        </div>
      </div>
    </div>

    <!--Notifications-->
    <fgb-notification-button></fgb-notification-button>

    <fgbcl-cart-button></fgbcl-cart-button>

    <!-- side nav -->
    <button
      class="nav-link btn d-flex align-items-center mx-2 px-0 justify-content-end"
      (click)="isNavOpen = !isNavOpen"
      id="namedropdown"
      attr.aria-label="{{ 'nav.account.menu.screenreader' | translate }}"
      tabindex="-1"
      focusTab
    >
      <i class="material-symbols-outlined text-white">menu</i>
    </button>
  </div>
</nav>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>

<div class="right-nav-menu-overlay" *ngIf="isNavOpen" [@rightMenuOverlayAnimation]></div>
<div class="right-nav-menu" [@rightNavAnimation]="isNavOpen ? 'open' : 'close'" [ngClass]="{ open: isNavOpen }">
  <div class="d-flex flex-column">
    <!-- Close Button -->
    <button type="button" class="btn-close position-absolute" (click)="isNavOpen = false" aria-label="Close"></button>

    <div class="member-card-container">
      <fgb-member-card [isDesktopMenu]="true"></fgb-member-card>
    </div>

    <div class="right-nav-menu-list">
      <!-- Nav Buttons -->

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/account']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-icons-outlined text-primary"> account_circle </span>
        <span class="nav-text">{{ 'nav.account' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/subscriptions']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-icons text-primary"> card_membership </span>
        <span class="nav-text">{{ 'account.nav.subscriptions' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/earn']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-icons text-primary"> loyalty </span>
        <span class="nav-text">{{ 'nav.earn' | translate }}</span>
      </a>


      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/worksheet']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-symbols-outlined text-primary"> animated_images </span>
        <span class="nav-text">{{ 'nav.gallery' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/ticketTransfer']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-icons"> </span>
        <span>{{ 'nav.ticket.transfer' | translate }}</span></a
      >

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/guardians']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-icons"> </span>
        <span>{{ 'nav.guardian' | translate }}</span></a
      >

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/managetickets']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-icons"> </span>
        <span>{{ 'nav.ticket.load' | translate }}</span></a
      >

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/benefits']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        ><span class="material-icons"> </span><span>{{ 'nav.benefits' | translate }}</span></a
      >

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/arenacashtransfer']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-icons"> </span>
        <span>{{ 'nav.arena.cash' | translate }}</span>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/splitTransactions']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-icons"> </span>
        <span>{{ 'nav.split.transactions' | translate }}</span>
      </a>

      <div class="help-wrapper">
        <div class="right-nav-menu-item help-dropdown">
          <span class="material-icons text-primary">info</span>
          <span class="nav-text">{{ 'nav.help' | translate }}</span>
          <span class="material-icons arrow">expand_more</span>
        </div>

        <div class="help-submenu">
          <a class="right-nav-sub-item" data-bs-dismiss="offcanvas" [routerLink]="['/terms']">
            {{ 'nav.terms' | translate }}
          </a>
          <a class="right-nav-sub-item" data-bs-dismiss="offcanvas" [routerLink]="['/faq']">
            {{ 'nav.faq' | translate }}
          </a>
          <a class="right-nav-sub-item" data-bs-dismiss="offcanvas" [routerLink]="['/contact']">
            {{ 'nav.contact.us' | translate }}
          </a>
        </div>
      </div>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/rewards/wallet']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="nav-item-title-div">
          <fgbcl-wallet-text-with-badge [count]="unredeemedCount">
            <span class="material-icons text-primary"> account_balance_wallet </span>
            <span class="navt-text wallet-text">{{ 'nav.wallet' | translate }}</span>
          </fgbcl-wallet-text-with-badge>
        </div>
      </a>

      <a
        class="right-nav-menu-item"
        data-bs-dismiss="offcanvas"
        [routerLink]="['/link-child']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="material-symbols-outlined"> family_star </span>
        <span>{{ 'nav.kids' | translate }}</span>
      </a>

      <a class="log-out" data-bs-dismiss="offcanvas" (click)="logout()">
        <i class="material-icons font-size-14 fw-bold">logout</i>
        <div class="nav-text">{{ 'nav.log.out' | translate }}</div>
      </a>
    </div>
  </div>
</div>
